<template>
  <layout titlePage="Configurações (RSVP)" :route="routerBack">
    <submenuBack v-if="hasToShowNewMenu" backRoutePath="/rsvp/" />
    <section class="c-rsvp-config">
      <div
        v-if="!wedSiteInfo"
        class="columns columns--full is-vcentered is-centered"
      >
        <base-reload :isReload="false" :dark="true" label="..." />
      </div>

      <div v-else class="columns columns--full is-vcentered">
        <div class="column">
          <div class="container c-rsvp-config__content c-rsvp-config__form">
            <div class="is-flex is-justify-content-end">
              <BaseSaving ref="savingForm" @closed="setSaving(false)" />
            </div>

            <template v-if="hasPartnerRsvp">
              <div>
                <tag-icon class="mb-4" />
                <p class="c-rsvp-config__title has-text-primary">
                  <b>Configurações</b>
                </p>
                <p class="c-rsvp-config__description">
                  Insira o título e introdução que deseja exibir nesta seção.
                </p>
              </div>
              <FormConfigPage />
            </template>

            <template v-else-if="rsvpConfigs && !hasPartnerRsvp">
              <div>
                <tag-icon class="mb-4" />
                <p class="c-rsvp-config__title has-text-primary">
                  <b>Configurações</b>
                </p>
                <p class="c-rsvp-config__description">
                  Defina qual modelo de confirmação de presença você gostaria de
                  disponibilizar para os seus convidados
                </p>
              </div>
              <SelectConfirmation
                v-if="rsvpConfigs"
                :mode="rsvpConfigs.mode || 'opened'"
                @selected="selectedConfirmation"
              />
              <ConfigsFormClosed v-if="selected == 'closed'" />
              <ConfigsFormOpened v-else />
            </template>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import layout from '@/layouts/Default.vue'
import submenuBack from '@/layouts/parts/SubmenuBack.vue'
import FormConfigPage from '@/components/Rsvp/FormConfigPage.vue'
import ConfigsFormOpened from '@/components/Rsvp/ConfigsFormOpened.vue'
import ConfigsFormClosed from '@/components/Rsvp/ConfigsFormClosed.vue'
import TagIcon from '@/components/Rsvp/TagIcon.vue'
import SelectConfirmation from '@/components/Rsvp/SelectConfirmation.vue'
import BaseSaving from '@/components/BaseSaving.vue'
import RsvpApi from '@/lib/api/Rsvp'

const API_LEGACY_URL = process.env.VUE_APP_API_LEGACY_URL

export default {
  components: {
    layout,
    submenuBack,
    ConfigsFormOpened,
    FormConfigPage,
    TagIcon,
    SelectConfirmation,
    ConfigsFormClosed,
    BaseSaving,
  },

  metaInfo: {
    title: 'RSVP - Configurações',
  },

  computed: {
    ...mapGetters({
      logonToken: 'app/logonToken',
      wedSiteInfo: 'app/getWedSiteInfo',
      rsvpConfigs: 'getRsvpConfigs',
    }),

    saving() {
      return this.$store.state.gifts.saving
    },

    hasPartnerRsvp() {
      return (
        this.wedSiteInfo.parceria &&
        this.wedSiteInfo.parceria != 'assessoriavip_sem_rsvp'
      )
    },

    routerBack() {
      if (
        this.logonToken &&
        this.logonToken.token &&
        this.wedSiteInfo &&
        this.wedSiteInfo.parceria
      ) {
        return {
          external:
            API_LEGACY_URL +
            `/${this.logonToken.token_payload.wed_id}/#/admin/abas`,
        }
      }
      return { name: 'rsvp' }
    },

    hasToShowNewMenu() {
      return this.$store.state.app.wedSiteInfo.site_menu_versao ? true : false
    },
  },

  data() {
    return {
      selected: 'opened',
    }
  },

  watch: {
    saving() {
      this.$refs.savingForm.toggleWithDelay()
    },

    rsvpConfigs() {
      this.selected = this.rsvpConfigs.mode
    },
  },

  mounted() {
    this.fetchRsvpConfigs()
  },

  methods: {
    ...mapActions({
      notification: 'app/setNotification',
      setSaving: 'gifts/setSaving',
      fetchRsvpConfigs: 'fetchRsvpConfigs',
      setRsvpConfigs: 'setRsvpConfigs',
    }),

    selectedConfirmation(mode) {
      this.saveChangedMode(mode)
      this.selected = mode
    },

    saveChangedMode(mode) {
      const rsvpApi = new RsvpApi(this.logonToken)

      const configs = {
        ...this.rsvpConfigs,
        mode,
      }

      rsvpApi
        .setConfigRsvp(configs)
        .then((response) => {
          if (response.status === 201) {
            this.setRsvpConfigs(configs)
            this.notification({
              message: 'Configurações salvas com sucesso!',
              show: true,
            })
          }
        })
        .catch(() => {
          this.notification({
            message: 'Erro no salvamento. Por favor, tente novamente.',
            show: true,
            class: 'is-error',
          })
        })
        .finally(() => {
          this.setSaving(false)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/bit-assets/vendors/bulma/material-form';

.c-rsvp-config {
  padding: 0 20px 40px;
  color: $neutral;

  .outlined-field,
  .form-field input {
    border-radius: 8px;
    border: 1px solid rgba(180, 197, 214, 0.5);
    padding: 26px;
    color: $neutral !important;
    gap: 8px;

    &:focus {
      outline: none;
      border: 1px solid $neutrallight;
      box-shadow: 0px 0px 3px 0px $neutrallight !important;
    }
  }

  &__body {
    .title-form {
      color: $neutral;
      font-size: 20px;
      font-weight: 700;
      line-height: 100%;
    }

    .label {
      font-size: 16px !important;
      top: -32px !important;
      color: $neutral !important;
      line-height: 1.14;
      font-weight: bold;

      @media (max-width: 600px) {
        &--double-row {
          top: -39px !important;
        }
      }
    }

    textarea {
      padding: 16px !important;
    }

    div.is-multiline {
      display: flex;
      gap: 32px;
      margin-top: 0;

      @media (max-width: $tablet) {
        flex-direction: column;
      }

      & > .column {
        padding: 0 0.75rem;
      }
    }

    .form-field {
      .control.has-icons-right .icon.is-right {
        top: 3.5px;
        font-size: 20px;
      }
    }

    .outlined-body {
      display: flex;
      min-height: 96px;
      padding: 16px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      border-radius: 8px;
      border: 1px solid #d9e2eb;
      font-size: 16px;

      @media (max-width: $mobile) {
        p.has-text-weight-bold {
          font-size: 14px;
        }

        flex-direction: column;
        align-items: start;
      }

      .label-group {
        @media (max-width: $mobile) {
          gap: 16px;
          flex-direction: column;
          align-items: start !important;

          p.has-space-bottom {
            margin-bottom: 16px;
          }
        }
      }
    }

    .form-switch {
      @media (max-width: $mobile) {
        flex-direction: row;
        align-items: end;
        gap: 16px;
      }
    }

    .form-date {
      @media (max-width: $mobile) {
        flex-direction: column;
      }
    }

    .input-select {
      box-shadow: none;
      border: none;
      border-radius: 8px;
      border: 1px solid rgba(180, 197, 214, 0.5);
      background: white;
      padding: 32px 16px;
      width: auto;
      cursor: pointer;

      select {
        cursor: pointer;
      }
    }

    textarea {
      height: auto;
    }

    .checkbox.input {
      display: flex;
      align-items: flex-start;
      height: auto;
      border: none;
      box-shadow: none;
      padding: 0;
      background-color: transparent;
      color: $neutral;

      input {
        width: auto;
        margin-right: 10px;
        margin-left: 7px;

        @media (min-width: $tablet) {
          width: 15px;
        }
      }

      p {
        font-size: 16px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;

        span {
          font-weight: normal;
        }
      }
    }
  }

  &__btn {
    text-align: center;
    margin-top: 30px;

    @media (min-width: $tablet) {
      text-align: right;
      margin-top: 40px;
    }

    button,
    a {
      width: 100%;
      margin: 0;
      margin-bottom: 20px;

      @media (min-width: $tablet) {
        width: auto;
        margin-left: 15px;
      }
    }
  }

  .notification {
    @include position(fixed, auto, 0, 2em, 0);
    padding: 1rem 2.5rem 1rem 1.5rem;
    margin: 15px auto 0;
    max-width: 350px;
    z-index: 10;

    > .delete {
      @include position(absolute, 50%, 0.5rem, auto, auto, -50%);
    }
  }

  &__content {
    padding-top: 8px;
    padding-bottom: 0;

    @media (min-width: $tablet) {
      padding-top: 64px;
      padding-bottom: 64px;
    }
  }

  &__title {
    font-size: 24px;
    line-height: 1;
    margin-bottom: 8px;

    @media (max-width: $tablet) {
      font-size: 20px;
    }
  }

  &__description {
    color: $neutral;
    font-size: 16px;
    line-height: 100%;
    font-weight: 700;
  }
}

.control select {
  color: $neutral;
}

.control > span > select {
  height: calc(100% - 4px);
  padding-right: 50px;
}

.control select > option {
  background-color: $white;
  color: $neutral;
}

.select:not(.is-multiple):not(.is-loading)::after {
  border-color: $neutral;
}

.layout {
  background: white;
}
</style>
